const CURRENCIES = { GBP: "GBP", EUR: "EUR", USD: "USD" };

export default CURRENCIES;
